import { useEffect } from 'react';
import useRequest from '@/websdk/utils/request';

export default function (devId) {
  const { data, exec } = useRequest({ url: '', name: 'GET_DEV_RESUME', manual: true });

  useEffect(() => {
    if (devId) {
      let url = `/api/devices/${devId}/base/resume`;
      exec(url);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [devId]);

  return data || [];
}
